import { ReactNode, useContext } from "react";
import { createPortal } from "react-dom";
import { HeaderActionsContext } from "components/AppLayout/HeaderActionsContext";

/**
 * Portals action buttons into the island header's right side. Use from a page
 * that renders inside a shell-owned header (e.g. a Books Settings tab) so its
 * actions sit next to the title instead of in the content body. The children
 * stay in the caller's React subtree, so shared state (modals, panes) keeps
 * working.
 */
export const HeaderActions = ({ children }: { children: ReactNode }) => {
  const { slot } = useContext(HeaderActionsContext);

  if (!slot) {
    return null;
  }

  return createPortal(children, slot);
};
